import React from 'react';
import { useLocation } from "@reach/router";

// Components //
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";

// Utils //
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS , INLINES } from "@contentful/rich-text-types";

// Interface //
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';

// Styles //
import "./ApplicationRequirements.scss";

const ApplicationRequirements = (props: ReferenciaContenido) => {
    const location = useLocation();
    const shouldUseIcons = location.pathname.includes("por-talento") || 
                      location.pathname.includes("proyectos-inclusion-laboral/alianza") ||
                      location.pathname.includes("proyectos-inclusion-laboral/empleo-mayores-de-50") ||
                      location.pathname.includes("empresas/agencia-transnacional/") ||
                      location.pathname.includes("proyectos-inclusion-laboral/migrantes-colombianos-retornados");

    const CheckIcon: React.FC = () => {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="21.637" height="15.515" viewBox="0 0 21.637 15.515">
                <path id="Trazado_77673" data-name="Trazado 77673" d="M95.991,102.814,85.5,113.308l-4.809-4.81a1.855,1.855,0,1,0-2.623,2.623l6.121,6.121a1.855,1.855,0,0,0,1.312.543h0a1.855,1.855,0,0,0,1.312-.543l11.806-11.805a1.855,1.855,0,0,0-2.623-2.623Z" transform="translate(-77.521 -102.271)" fill="#ee2b7b"/>
            </svg>
        );
    }
    const contentfulRichTextwithIcon = (contentfulText: any) => {
        const contentfulRender = {
            renderNode: {
                [INLINES.HYPERLINK]: ({ data }: any, children) => (
                    <a
                        style={{ color: "var(--color-magenta-white)" }}
                        href={data.uri}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                    >
                        {children}
                    </a>
                ),
                [BLOCKS.PARAGRAPH]: ( _node, children) => {
                    const filteredChildren = React.Children.toArray(children).filter(child => child !== null && child !== undefined && child !== "");
                    return (
                        <div style={{ display: 'flex' , flexDirection: 'row', gap: '15px' }}>
                            {filteredChildren.length > 0 && (
                                <span style={{ marginTop: '3px' }} >
                                    <CheckIcon />
                                </span>
                            )}
                            <p className='o-application-requirements__option-text'>
                                {children}
                            </p>
                        </div>
                    );
                },
            },
            renderText: (text) =>
                text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
        }
        return documentToReactComponents(contentfulText, contentfulRender);
        
    };
    return (
        <div className={`o-application-requirements ${props.contentful_id === "3ekxnvFiYPhwuugBnMOinF" && "o-application-requirements--route"}`}>
            <div className="container">
                <div className="o-application-requirements__inner">
                    <div className="o-application-requirements__inner__text">
                        <TitleSection title={props.tituloGeneral} />
                        {props.descripcion && (shouldUseIcons ? contentfulRichTextwithIcon(props.descripcion.json) : contentfulRenderOptions(props.descripcion?.json))}
                        {props.tituloBoton && (
                            <Button
                                type="link"
                                text={props.tituloBoton}
                                classname={`a-button__magenta gtm_conocer_requisitos_home_subsidio_desempleo_componente_requisitos big center`}
                                isDisabled={false}
                                href={props.redireccionBoton}
                            />
                        )}
                    </div>
                    <div className="o-application-requirements__inner__image">
                        <img className={`o-application-requirements__img ${props.contentful_id === "3ekxnvFiYPhwuugBnMOinF" ? "no-image-mobile" : ""}`} src={props.imagenPrincipal.file.url} alt={props.imagenPrincipal.file.fileName} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ApplicationRequirements;
